import SingleChargingSessionInfo from './SingleChargingSessionInfo'

export const SingleChargingSession = {
    Info: SingleChargingSessionInfo
}
